<script lang="ts">
import { modalRegister } from '@/services/modals';
import AlertModal from './AlertModal.vue';

export async function alertModal(args: { title: string; message: string; buttonLabel?: string }): Promise<void> {
  return modalRegister({
    content: AlertModal,
    bindings: args,
  });
}
</script>

<script setup lang="ts">
import BootstrapModal from '@/components/modals/BootstrapModal.vue';
import { useTemplateRef } from 'vue';
import { type ModalItem } from '@/services/modals';
import { Button } from '../../../cross-app-frontend/button';

withDefaults(
  defineProps<{
    modalID: ModalItem['modalID'];
    title: string;
    message: string;
    buttonLabel?: string;
  }>(),
  { buttonLabel: 'Okay' },
);

const modal = useTemplateRef('modal');
defineExpose({ modal });
</script>

<template>
  <BootstrapModal ref="modal" :title="title" :modalID="modalID">
    <p style="white-space: pre-line">{{ message }}</p>

    <template #footer="{ close }">
      <Button type="button" variant="default" @click="close()">
        {{ buttonLabel }}
      </Button>
    </template>
  </BootstrapModal>
</template>
